<template>
  <div class="punch-the-clock" v-if="rolePower">
    <!-- <title-bar class="title-bar-view" :title="'专业支持'" :showAll="false"></title-bar> -->
    <div class="task-list" v-if="journeyInfoFlag">
      <div class="task-item">
        <div class="study-target-container">
          <div class="study-target-title">当前学习目标：</div>
          <div class="study-target-content" v-html="stageEvaluationCriteria"></div>
        </div>
        <div class="separator-line"></div>
        <div class="content-view">
          <div class="content-container">
            <!-- <div class="sub-title">打卡任务</div> -->
            <div class="missions-list" v-if="stageTasks.length > 0">
              <!-- 任务一 -->
              <div class="mission-item" v-for="(item1, index1) in stageTasks" :key="index1">
                <div class="item-title-container">
                  <div class="item-point"></div>
                  <div class="item-title">{{ item1 && item1.taskType }}</div>
                </div>
                <div class="item-content">
                  <div class="target-list">
                    <div class="target-item-container" v-for="(item2, index2) in item1.list" :key="index2">
                      <div class="title">·{{ item2 && item2.taskName }}：</div>
                      <div class="completed-times">
                        {{ item2 && item2.completedCount }}次
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="separator-line" v-if="stageTasks.length > 0"></div>
            <div class="tips-view" @click="goJourneyReport">
            <!-- <div class="tips-view"  v-track="{functionName: '旅程报告'}" @click="goJourneyReport"> -->
              <div class="tips-container">
                <img class="tips-img" src="../assets/images/home/Tips@3x.png" alt="" />
                <div class="tips-text">详见旅程报告</div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="trapezoid-container">
              <div class="trapezoid-text">当前</div>
            </div> -->
        <div class="vertical-bar"></div>
      </div>
    </div>
    <div class="clock-in-task-container" v-else>
      <div class="no-task-container">
        <img class="none-img" src="../assets/images/home/none.png" alt="" />
        <div class="no-task-text">暂无信息</div>
      </div>
    </div>
  </div>
</template>

<script>
import TitleBar from './TitleBar.vue'
import { BOOL_GOAL, BOOL_SENIOR_EMPLOYEE } from '@/utils/configRoles'
// import { mapGetters } from "vuex";
import { getJourneyReport, getJourneyStageData, getStageTask } from '@/api/api'
import { checkObject } from '@/utils/util'
export default {
  name: 'ProfessionalSupport',
  components: {
    TitleBar
  },
  data() {
    return {
      journeyInfo: {},
      stageEvaluationCriteria: '',
      stageTasks: []
    }
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    },
    // journeyInfo对象不为空返回true 为空返回else
    journeyInfoFlag() {
      return checkObject(this.journeyInfo)
    },
    // 是否为目标EP术者 或者 大主任兼学员
    rolePower() {
      return BOOL_GOAL || BOOL_SENIOR_EMPLOYEE
    }
  },
  mounted() {
    if (this.rolePower) {
      this.getJourneyInfo()
    }
  },
  methods: {
    getJourneyInfo() {
      let hosHcp = this.userInfo.multiCode
      // let hosHcp = 'MULD100000737'
      if (hosHcp === '' || hosHcp === undefined || hosHcp === null) {
        console.log('multiCode 为空')
        return
      }
      getJourneyReport({ multiCode: hosHcp }).then(res => {
        if (res && res.data) {
          this.journeyInfo = JSON.parse(JSON.stringify(res.data))
          this.standardClearance()
          this.stageTask()
        }
        // if (res) {
        //   this.journeyInfo = JSON.parse(JSON.stringify(res))
        //   if (checkObject(this.journeyInfo)) {
        //     if (checkObject(this.journeyInfo.currentJourneyStage) && checkObject(this.journeyInfo.currentJourneyStage.currentStage)) {
        //       let stageEvaluationCriteria = this.journeyInfo.currentJourneyStage.currentStage.stageEvaluationCriteria
        //       let pattern = /\(+[0-9]+\)|;/gi
        //       this.journeyInfo.currentJourneyStage.currentStage.stageEvaluationCriteria = stageEvaluationCriteria.replace(pattern, function (rs) {
        //         return '<br>' + rs
        //       })
        //       let stageTask = this.journeyInfo.currentJourneyStage.currentStage.stageTask
        //       if (stageTask) {
        //         stageTask = stageTask.filter(item => {
        //           return item.taskType === '病例复盘' || item.taskType === '模拟器练习'
        //         })
        //         this.journeyInfo.currentJourneyStage.currentStage.stageTask = stageTask
        //       }
        //     }
        //     for (let index1 = 0; index1 < this.journeyInfo.journeys.length; index1++) {
        //       const element1 = this.journeyInfo.journeys[index1]
        //       for (let index2 = 0; index2 < element1.journeyStages.length; index2++) {
        //         const element2 = element1.journeyStages[index2]
        //         element2.stageTask = element2.stageTask.filter(item => {
        //           return item.taskType === '病例复盘' || item.taskType === '模拟器练习'
        //         })
        //       }
        //       element1.journeyStages.sort((a, b) => {
        //         return a.stageSequence - b.stageSequence
        //       })
        //     }
        //     console.log('🚀 ~ file: new-index.vue:1473 ~ .then ~ journeyInfo sort', this.journeyInfo)
        //   }
        // }
      })
      // .then(() => {
      //   getJourneyOpenInfo()
      // })
    },
    // 获取旅程阶段信息 过关标准
    standardClearance() {
      if (this.journeyInfo.currentJourney) {
        let params = {
          journeyName: this.journeyInfo.currentJourney,
          name: this.journeyInfo.currentStage
        }
        getJourneyStageData(params).then(res => {
          console.log('ps standardClearance', res)
          if (res && res.data) {
            // 处理换行问题
            let eva = res.data.evaluationCriteria
            let pattern1 = /\(+[0-9]+\)/gi
            let pattern2 = /;|:/gi
            if (pattern1.test(eva)) {
              this.stageEvaluationCriteria = eva.replace(pattern1, rs => {
                return '<br>' + rs
              })
            } else if (pattern2.test(eva)) {
              this.stageEvaluationCriteria = eva.replace(pattern2, rs => {
                return rs + '<br>'
              })
            } else {
              this.stageEvaluationCriteria = eva
            }
          }
        })
      }
    },
    // 获取旅程阶段任务
    stageTask() {
      let params = {
        multiCode: this.userInfo.multiCode,
        // multiCode: 'MULD100002343',
        journeyName: this.journeyInfo.currentJourney,
        stageName: this.journeyInfo.currentStage
        // stageName: '复杂持续性房颤处理'
      }
      getStageTask(params).then(res => {
        console.log('ps stageTask', res)
        if (res && res.data) {
          // 处理tasks数据问题
          let stageTasks = JSON.parse(JSON.stringify(res.data))
          if (stageTasks.length > 0) {
            // 拿到所有任务类型的名称
            let stageTaskTypeList = stageTasks.map(item => {
              return item.taskType
            })
            const resultArr = Array.from(new Set(stageTaskTypeList))
            // 把相同的任务类型放进同一个数组内
            let arri = []
            for (let j = 0; j < resultArr.length; j++) {
              const element2 = resultArr[j]
              let arrj = stageTasks.filter(item1 => {
                return item1.taskType === element2
              })
              let obj = {}
              obj.taskType = element2
              obj.list = arrj
              arri.push(obj)
            }
            console.log('arri', arri)
            this.stageTasks = JSON.parse(JSON.stringify(arri))
            console.log('🚀 ~ file: JourneyUpdatePopup.vue:178 ~ getStageTask ~ this.stageTasks:', this.stageTasks)
          }
        }
      })
    },
    goJourneyReport() {
      // this.$router.push('/journeyReport')
    }
  }
}
</script>

<style lang="less" scoped>
.punch-the-clock {
  // margin-top: 16px;
  // padding: 0 12px;
  position: relative;
  overflow-x: hidden;
  .task-list {
    margin-top: 20px;
    background-color: #ffffff;
    width: 351px;
    // min-height: 150px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    .task-item {
      width: 351px;
      // min-height: 150px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      position: relative;
      .study-target-container {
        margin-left: 17px;
        display: flex;
        min-height: 50px;
        // align-items: center;
        .study-target-title {
          width: 84px;
          height: 17px;
          font-size: 12px;
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 400;
          color: #000000;
          line-height: 17px;
        }
        .study-target-content {
          width: 241px;
          min-height: 17px;
          font-size: 12px;
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 400;
          color: #000000;
          line-height: 17px;
          display: -webkit-box;
          overflow: hidden;
          text-overflow: ellipsis;
          // white-space: nowrap;
          -webkit-line-clamp: 6;
          -webkit-box-orient: vertical;
          flex: 1;
        }
      }
      .content-view {
        width: 351px;
        min-height: 50px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background-color: #ffffff;
        border-radius: 8px;
        // margin-top: 16px;
        position: relative;
        .content-container {
          width: 351px;
          min-height: 50px;
          // min-height: 275px;
          position: relative;
        }
      }
      .trapezoid-container {
        position: absolute;
        top: -9px;
        left: 15px;
        width: 35px;
        height: 0px;
        border-top: 0px solid transparent;
        border-right: 6px solid transparent;
        border-bottom: 15px solid #EB1700;
        border-left: 0px solid transparent;
        // border-radius: 2px;
        // position: relative;
        margin-right: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        .trapezoid-text {
          position: absolute;
          top: 0px;
          width: 20px;
          height: 14px;
          font-size: 10px;
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 400;
          color: #ffffff;
          line-height: 14px;
        }
      }
      .separator-line {
        width: 338px;
        height: 1px;
        background-color: #f0f0f0;
        margin: 16px 0 0 7px;
      }
      .tips-view {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        height: 28px;
        margin-top: 4px;
      }
      .vertical-bar {
        position: absolute;
        width: 7px;
        height: 100%;
        // min-height: 275px;
        left: 0;
        top: 0;
        background-color: #EB1700;
        box-shadow: 0px 0px 20px 0px rgba(43, 41, 41, 0.08);
        border-radius: 100px 0px 0px 100px;
      }
      .sub-title {
        margin-top: 16px;
        margin-left: 17px;
        width: 48px;
        height: 18px;
        font-size: 12px;
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 500;
        color: #2b2b2b;
        line-height: 18px;
      }
      .missions-list {
        width: 351px;
        min-height: 22px;
        max-width: 351px;
        margin-left: 17px;
        display: flex;
        position: relative;
        flex-wrap: wrap;
        .mission-item {
          margin-top: 8px;
          position: relative;
          // width: 50%;
          // flex: 1;
          .item-title-container {
            display: flex;
            align-items: center;
            .item-point {
              width: 4px;
              height: 4px;
              background-color: #EB1700;
              margin-right: 6px;
              border-radius: 50%;
            }
            .item-title {
              width: 150px;
              height: 18px;
              font-size: 13px;
              font-family: Source Han Sans CN, Source Han Sans CN;
              font-weight: 400;
              color: #2b2b2b;
              line-height: 18px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              flex: 1;
            }
          }
          .item-content {
            width: 100%;
            margin-top: 10px;
            .target-list {
              width: 100%;
              .target-item-container {
                display: flex;
                align-items: center;
                .title {
                  max-width: 160px;
                  height: 17px;
                  font-size: 12px;
                  font-family: Source Han Sans CN, Source Han Sans CN;
                  font-weight: 400;
                  color: #2b2b2b;
                  line-height: 17px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }
                .completed-times {
                  height: 17px;
                  font-size: 12px;
                  font-family: Source Han Sans CN, Source Han Sans CN;
                  font-weight: 400;
                  color: #858585;
                  line-height: 17px;
                }
              }
              .target-item-container:not(:first-child) {
                margin-top: 8px;
              }
            }
          }
        }
      }
      .mission-item:nth-child(2n) {
        margin-left: 3px;
      }
      .tips-container {
        margin-right: 8px;
        width: 80px;
        display: flex;
        align-items: center;
        .tips-img {
          width: 11px;
          height: 11px;
          margin-right: 1px;
        }
        .tips-text {
          width: 60px;
          height: 14px;
          font-size: 10px;
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 400;
          color: #5b5f6a;
          line-height: 14px;
        }
      }
    }
    .task-item:first-child {
      padding-top: 16px;
    }
    // .task-item:last-child {
    //   padding-bottom: 38px;
    // }
  }
  // .tips-container {
  //   position: absolute;
  //   bottom: 16px;
  //   right: 18px;
  //   width: 80px;
  //   display: flex;
  //   align-items: center;
  //   .tips-img {
  //     width: 11px;
  //     height: 11px;
  //     margin-right: 1px;
  //   }
  //   .tips-text {
  //     width: 60px;
  //     height: 14px;
  //     font-size: 10px;
  //     font-family: Source Han Sans CN, Source Han Sans CN;
  //     font-weight: 400;
  //     color: #5b5f6a;
  //     line-height: 14px;
  //   }
  // }
  .clock-in-task-container {
    width: 351px;
    height: 86px;
    background: #ffffff;
    border-radius: 4px 4px 5px 5px;
    .no-task-container {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .none-img {
        width: 60px;
        height: 52px;
      }
      .no-task-text {
        margin-top: 3px;
        height: 14px;
        font-size: 10px;
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 400;
        color: #5b5f6a;
        line-height: 14px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ProfessionalSupport.vue